import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import { CnMessage, Select, Form, Field, Grid, CnButton, CnIcon, CnCard, } from '@alife/cn-ui';
import { PayMethods } from '../../const';
import { getVasSelfPayerInfo, saveVasSelfPayerInfo } from '../../api';
const { Row, Col } = Grid;
const FormItem = Form.Item;
export default function AddPlayer(props) {
    const { asnCode, canEdit, setCanAddService, selfVasPayerInfo, setChangeBlg, setChange, setValues, setRemarks, } = props;
    const addPayerField = Field.useField();
    const [payerLoading, setPayerLoading] = useState(false); // 会员信息 - 保存
    const [payerList, setPayerList] = useState([]); // 会员信息 - 列表
    // 获取 - 会员信息 + 会员列表
    const getPayerInfo = useCallback(() => {
        getVasSelfPayerInfo({
            asnCode,
        }).then((res) => {
            const { data } = (res || {});
            const { list = [], vasSelfPayerInfo, // 会员信息
             } = data;
            setPayerList(list);
            if (selfVasPayerInfo && selfVasPayerInfo?.isDisable) {
                const { vasSelfPayerName, vasSelfAccountType } = selfVasPayerInfo;
                addPayerField.setValues({
                    vasSelfPayerName: vasSelfPayerName || null,
                    vasSelfAccountType: vasSelfAccountType || null,
                });
                if (vasSelfPayerName) {
                    setCanAddService(true);
                }
            }
            else if (vasSelfPayerInfo) {
                addPayerField.setValues({
                    vasSelfPayerName: vasSelfPayerInfo?.value || null,
                    vasSelfAccountType: vasSelfPayerInfo?.vasSelfAccountType || null,
                });
                if (vasSelfPayerInfo?.value) {
                    setCanAddService(true);
                }
            }
            else {
                addPayerField.setValues({
                    vasSelfPayerName: null,
                    vasSelfAccountType: null,
                });
                setCanAddService(false);
            }
            setChange(addPayerField.getValue('vasSelfAccountType'));
        });
    }, [asnCode, addPayerField, setCanAddService, selfVasPayerInfo]);
    useEffect(() => {
        getPayerInfo(); // 获取会员信息 + 客户名称
    }, [getPayerInfo]);
    // 会员信息 - 保存 - 接口请求
    const savePayerRequest = (params) => {
        saveVasSelfPayerInfo({
            asnCode,
            ...params,
        })
            .then(() => {
            setCanAddService(true);
            CnMessage.success($i18n.get({ id: 'SavedSuccessfully', dm: '保存成功' }));
        })
            .catch((error) => {
            CnMessage.error(error?.message);
        })
            .finally(() => {
            setPayerLoading(false);
        });
    };
    // 会员信息 - 保存 - 数据处理
    const onSavePayer = () => {
        addPayerField.validate((error, values) => {
            if (!error) {
                const { vasSelfPayerName, vasSelfAccountType } = values;
                const { label = '' } = (payerList &&
                    payerList.find((item) => {
                        return item.value === vasSelfPayerName;
                    })) ||
                    {};
                setPayerLoading(true);
                const vasSelfPayer = (label && label?.split(' ')) || [];
                const payerInfo = vasSelfPayer && {
                    vasSelfPayerId: vasSelfPayer?.[1] || '',
                    vasSelfPayerName: vasSelfPayer?.[0] || '',
                    vasSelfAccountType,
                };
                setChangeBlg(vasSelfAccountType);
                if (vasSelfAccountType == '2') {
                    setValues(null);
                    setRemarks('');
                }
                savePayerRequest(payerInfo);
            }
        });
    };
    const onNameChange = (v) => {
        if (v) {
            const accountType = payerList?.find((item) => item.value === v)?.vasSelfAccountType;
            addPayerField.setValues({
                vasSelfAccountType: accountType,
            });
            addPayerField.setError('vasSelfAccountType', undefined);
        }
        else {
            addPayerField.setValues({
                vasSelfAccountType: undefined,
            });
        }
    };
    return (React.createElement(Form, { field: addPayerField },
        React.createElement(CnCard, { title: $i18n.get({
                id: 'SelectPaymentInformation',
                dm: '1.选择支付信息',
            }), action: React.createElement(React.Fragment, null, canEdit ? (React.createElement(CnButton, { loading: payerLoading, disabled: selfVasPayerInfo?.isDisable || !canEdit, className: 'right-btn', type: 'secondary', onClick: onSavePayer }, $i18n.get({ id: 'Save', dm: '保存' }))) : (React.createElement(CnButton, { className: 'right-btn', disabled: true, type: 'normal' },
                React.createElement(CnIcon, { type: 'lock' }),
                $i18n.get({ id: 'Locked', dm: '已锁定' })))) },
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 12 },
                    React.createElement(FormItem, { label: $i18n.get({
                            id: 'SettlementCustomerName',
                            dm: '结算客户名称',
                        }), name: 'vasSelfPayerName', required: true, requiredMessage: $i18n.get({
                            id: 'PleaseSelectTheNameOfThe_515199897',
                            dm: '请选择结算客户名称',
                        }) },
                        React.createElement(Select, { disabled: selfVasPayerInfo?.isDisable || !canEdit, showSearch: true, hasClear: true, dataSource: payerList, style: { width: '100%' }, onChange: onNameChange }))),
                React.createElement(Col, { span: 12 },
                    React.createElement(FormItem, { label: $i18n.get({ id: 'SettlementMethod', dm: '结算方式' }), name: 'vasSelfAccountType', required: true, requiredMessage: $i18n.get({
                            id: 'SettlementMethod',
                            dm: '结算方式',
                        }) },
                        React.createElement(Select, { disabled: true, showSearch: true, hasClear: true, dataSource: PayMethods, style: { width: '100%' } })))))));
}
